import gql from 'graphql-tag'

const UpdateRefundFromAirline = gql`
  mutation UpdateRefundFromAirline($input: UpdateRefundFromAirlineMutationInput!) {
    updateRefundFromAirline(input: $input) {
      claim {
        refundFromAirlineAmount,
        refundFromAirlineDate
      }
    }
  }
`

export { UpdateRefundFromAirline }



// WEBPACK FOOTER //
// ./src/mutations/UpdateRefundFromAirline.js